export default "__VITE_ASSET__DS9vnlw4__"